import React, { Component } from 'react'
import classNames from 'classnames';
import ListItemForm from 'pap/containers/common/input_fields/item_form';

const ListItem = React.createClass({
  removeItem(e, item) {
    e.preventDefault();
    e.stopPropagation();
    this.props.removeListItem(item);
  },

  editItem(e, index) {
    e.preventDefault();
    e.stopPropagation();
    this.props.editListItem(index);
  },

  render: function() {
    const { index, item, isURLSelector } = this.props;

    return (
      <li key={index} className="list-item">
        { isURLSelector ? <a href={item.url} target="_blank">{ item.url }</a> : item.title }

        <button className="btn btn-icon-only btn-delete" onClick={(e) => this.removeItem(e, item)}>
          <i className="fa fa-trash"/>
        </button>
        <button className="btn btn-icon-only btn-edit" onClick={(e) => this.editItem(e, index)}>
          <i className="fa fa-pencil"/>
        </button>
      </li>
    )
  }
});

export class PAPItemListInput extends Component {
  constructor(props) {
    super(props)

    this.state = { items: [] }

    this.showEditItemForm = this.showEditItemForm.bind(this)
    this.showAddItemForm = this.showAddItemForm.bind(this)
    this.getListItems = this.getListItems.bind(this)
    this.addListItem = this.addListItem.bind(this)
    this.updateListItem = this.updateListItem.bind(this)
    this.removeListItem = this.removeListItem.bind(this)
  }

  showAddItemForm(e) {
    e.preventDefault();
    this.props.displayFullScreen("item_add", {});
  }

  showEditItemForm(itemIdx) {
    this.props.displayFullScreen("item_edit", { itemIdx });
  }

  getListItems() {
    return this.props.input.value;
  }

  addListItem(item) {
    const currentValue = this.props.input.value || [];
    this.props.input.onChange(currentValue.concat(item));
  }

  updateListItem(item) {
    const { input, fullScreen } = this.props;
    const { itemIdx } = fullScreen.extraData;
    const currentValue = input.value || [];

    input.onChange([
      ...currentValue.slice(0, itemIdx),
      item,
      ...currentValue.slice(itemIdx + 1)
    ]);
  }

  removeListItem(itemToRemove) {
    const { isItemUrl, input } = this.props;
    const currentValue = input.value || [];
    const propName = isItemUrl? "url" : "title";
    input.onChange(currentValue.filter(i => i[propName] !== itemToRemove[propName]));
  }

  render() {
    const { isItemUrl, itemName, fullScreen } = this.props
    const items = this.getListItems(), onRemoveListItem = this.removeListItem;

    return (
      <div>
        <ul className="item-list">
          {items != undefined && items.length > 0 ?
            items.map((item, i) => {
              return (
                <ListItem key={i} index={i} item={item} isURLSelector={isItemUrl}
                  removeListItem={onRemoveListItem} editListItem={this.showEditItemForm} />
              )
            }) : <li>You haven&apos;t added any items yet.</li>}

          <li className="add-list-item">
            <button className="btn btn-text btn-with-icon align-text" onClick={this.showAddItemForm}>
              <i className="fa fa-plus-circle"/> Add a {itemName}
            </button>
          </li>

        </ul>

        { fullScreen && fullScreen.name === "item_add" &&
        <ListItemForm isURLSelector={isItemUrl} saveListItem={this.addListItem}
          itemName={itemName} hideFullScreen={this.props.hideFullScreen}/> }

        { fullScreen && fullScreen.name === "item_edit" &&
        <ListItemForm isURLSelector={isItemUrl} saveListItem={this.updateListItem}
          initialValues={items[fullScreen.extraData.itemIdx]}
          itemName={itemName} hideFullScreen={this.props.hideFullScreen}/> }
      </div>
    );
  }
};
